export const defaultModalRelatedProductsData = {
  isSliderInitialized: false,
  modalInstanceId: null
};

export const ActionType = {
  INIT_RELATED: `INIT_RELATED`,
  DESTROY_RELATED: `DESTROY_RELATED`
};
